import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export function useToastFromNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const shown = useRef(false);

  useEffect(() => {
    const message = location.state?.message;
    const type = location.state?.type || 'success'; // default: success

    if (message && !shown.current) {
      shown.current = true;

      // ✨ Dynamic toast
      toast[type](message); // π.χ. toast.success / toast.error

      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location, navigate]);
}
